import { makeAutoObservable } from 'mobx';
import { signUpFlowStatEnum, ISignUpFlowState, IInviteLink } from './types';

export interface ISignUpStore {
  errorMessage: string;
  setErrorMessager(error: string): void;
  signUpMethod: string;
  setSignUpMethod(method: string): void;
  isLoading: boolean;
  setIsLoading(loading: boolean): void;
  signUpFlowState: ISignUpFlowState;
  setSignUpFlowState(state: ISignUpFlowState): void;
  resetSignupStates(): void;
  invite: IInviteLink | null;
  setInvite(val: IInviteLink): void;
  readonly isWelcomeState: boolean;
  readonly isSetUpAccountState: boolean;
  resetSignupFlowState(): void;
}

export class SignUpStore implements ISignUpStore {
  errorMessage = '';
  signUpMethod = '';
  isLoading = false;
  signUpFlowState = {} as ISignUpFlowState;
  invite: IInviteLink | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setInvite(val: IInviteLink): void {
    this.invite = val;
  }

  setErrorMessager(error: string) {
    this.errorMessage = error;
  }

  setSignUpMethod(method: string) {
    this.signUpMethod = method;
    this.errorMessage = '';
  }

  setIsLoading(loading: boolean) {
    this.isLoading = loading;
  }

  setSignUpFlowState(state: ISignUpFlowState) {
    this.signUpFlowState = state;
    this.errorMessage = '';
  }

  resetSignupStates() {
    this.errorMessage = '';
    this.signUpMethod = '';
    this.isLoading = false;
    this.signUpFlowState = {} as ISignUpFlowState;
  }

  resetSignupFlowState() {
    this.signUpFlowState = {} as ISignUpFlowState;
    this.errorMessage = '';
  }

  get isWelcomeState() {
    return this.signUpFlowState.state === signUpFlowStatEnum.welcome;
  }
  get isSetUpAccountState() {
    return this.signUpFlowState.state === signUpFlowStatEnum.setUpAccount;
  }
}
